// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"3a00b52a","743":"8b82bac5"}[chunkId] + ".chunk.css";
};